module.exports = __webpack_public_path__ + "static/media/power.4e004b92.jpeg";